// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ynGHG","slider":"styles_slider__ZZG5j","zoomLevel":"styles_zoomLevel__A9LRo","fadeInOut":"styles_fadeInOut___i1D4","loader":"styles_loader__oC_Um"};